import React from 'react'
import Pt from 'prop-types'
import Ipt from 'react-immutable-proptypes'
import { DropdownButton, InputGroup, MenuItem } from 'react-bootstrap'

export default function RealmSelector({ currentRealm, realms, setData }) {
  if (!currentRealm && !realms) {
    return false
  }

  if ((currentRealm && (!realms || !realms.size)) || realms.size === 1) {
    return (
      <InputGroup.Addon>@{currentRealm || realms.first()}</InputGroup.Addon>
    )
  }

  return (
    <DropdownButton
      bsSize="large"
      componentClass={InputGroup.Button}
      id="realm-dropdown"
      title={currentRealm ? `@${currentRealm}` : 'Select Realm'}
    >
      {realms.map(realm => (
        <MenuItem key={realm} onSelect={() => setData('auth.realm', realm)}>
          @{realm}
        </MenuItem>
      ))}
    </DropdownButton>
  )
}

RealmSelector.propTypes = {
  currentRealm: Pt.string,
  realms: Ipt.orderedSet,
  setData: Pt.func.isRequired,
}



// WEBPACK FOOTER //
// ./src/components/Signup/ServiceDetail/RealmSelector.jsx